
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-social)"}},[_c('path',{attrs:{"d":"M22.674.001H1.324C.595.001 0 .593 0 1.326v21.35C0 23.406.594 24 1.325 24h11.493v-9.295H9.691v-3.622h3.127V8.413c0-3.1 1.893-4.788 4.658-4.788 1.326 0 2.463.099 2.794.142v3.24h-1.918c-1.503 0-1.793.715-1.793 1.764v2.312h3.587l-.47 3.622h-3.118v9.294h6.115c.732 0 1.326-.593 1.326-1.324V1.325C24 .593 23.406 0 22.674 0z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-social"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    